import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Archive, ArrowRight } from "lucide-react";
import { PageHero } from "../components/FormKit";

// Branded "gone" surface for offerings that have been permanently retired.
// Semantics: HTTP 410 Gone. We never expose the retired program names and we
// never silently redirect to Home. Renders inside Layout (header + footer),
// so it stays visible and accessible at 320 / 375 / 768px with no blank content.
export default function RetiredOffering() {
  useEffect(() => {
    document.title = "No longer available · TAVEN SYSTEM LLC";
  }, []);

  return (
    <div data-testid="retired-offering" data-http-status="410">
      <PageHero
        eyebrow="TAVEN Membership"
        title="This offering is no longer available"
        subtitle="We've streamlined how TAVEN membership works. This page has been permanently retired — explore our current membership to keep building, earning and growing your business."
      />
      <section className="py-12 px-4 md:px-8 lg:px-12 mx-auto max-w-3xl">
        <div className="bg-white border border-black/10 p-6 sm:p-10 text-center">
          <div className="w-14 h-14 rounded-full bg-taven-gold/15 flex items-center justify-center mx-auto">
            <Archive className="w-6 h-6 text-taven-gold" />
          </div>
          <h2 className="text-lg md:text-lg font-black font-display mt-5">Looking for a TAVEN membership?</h2>
          <p className="text-sm text-muted-foreground mt-2 max-w-xl mx-auto">
            The complete TAVEN seller membership covers everything you need in one place —
            catalog access, seller tools and marketplace eligibility.
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/membership"
              data-testid="retired-view-membership"
              className="inline-flex items-center justify-center gap-2 bg-taven-black text-white px-6 py-3 text-sm font-bold uppercase tracking-wider hover:bg-taven-gold hover:text-taven-black transition-colors"
            >
              View current membership <ArrowRight className="w-4 h-4" />
            </Link>
            <Link
              to="/"
              data-testid="retired-go-home"
              className="inline-flex items-center justify-center gap-2 border border-black/20 px-6 py-3 text-sm font-bold uppercase tracking-wider hover:border-taven-gold transition-colors"
            >
              Back to home
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
